import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { environment } from './../../environments/environment';
import { User } from './../models/user';
import { Organization, OrganizationMember } from './../models/organization';
import { StorageService } from './storage.service'
import { OrganizationService } from './organization.service'
import { Subject } from 'rxjs';
import { NavController } from '@ionic/angular';
import { Router } from '@angular/router';
import { AlertController } from '@ionic/angular';
import { UserService } from './user.service'
import { blobToBase64 } from '../utils'
import { Transaction, NativePurchases, PURCHASE_TYPE } from '@capgo/native-purchases';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  isLoggedIn: boolean = false;
  username: string | null = null;
  redirectUrl: string | null = null;
  notifications = []

  public _statusChange$ = new Subject<boolean>();
  public loginStatus$ = this._statusChange$.asObservable();
  
  public _logout$ = new Subject<boolean>();
  public logout$ = this._logout$.asObservable();

  public _notificationsUpdate$ = new Subject<boolean>();
  public notificationsUpdate$ = this._notificationsUpdate$.asObservable();


  constructor(
    private http: HttpClient,
    public storageService: StorageService,
    private router: Router,
    private navCtrl: NavController,
    public alertController: AlertController,
    private userService: UserService,
    private organizationService: OrganizationService,
  ) { }

  reloadRunning = false
  reloadUser(token: string, username: string, redirect_url: string | null = null) {
    this.username = username;

    if(this.reloadRunning){
      return null;
    }
    this.reloadRunning = true;

    const headers = new HttpHeaders({
      'Authorization': "Token " + token
    });
    return this.http.get<User>(environment.API_URL + 'userProfile/ws_private/User/', { headers: headers })
    .pipe(
      tap(user => {
        this.reloadRunning = false;
        if(user['success'] == false) {
          this.logoutDeleteLocalData();
          this._statusChange$.next(false);
        } else {
          if(this.userService.user == null) {
            this.userService.user = new User();
          }
          this.userService.user.id = user['id'];
          this.userService.user.addrCountry = user['addrCountry'];
          this.userService.user.addrCountry = user['addrCountry'];
          this.userService.user.addrPostalcode = user['addrPostalcode'];
          this.userService.user.addrStreet = user['addrStreet'];
          this.userService.user.avatar = user['avatar'];
          this.userService.user.birthday = user['birthday'];
          this.userService.user.email = user['email'];
          this.userService.user.firstName = user['firstName'];
          this.userService.user.languageCode = user['languageCode'];
          this.userService.user.gender = user['gender'];
          this.userService.user.lastName = user['lastName'];
          this.userService.user.phoneNumber = user['phoneNumber'];
          this.userService.user.success = user['success'];
          this.userService.user.identifier = user['identifier']
          this.userService.user.publicPageIsActive = user['publicPageIsActive']
          this.userService.user.postDefaultVisiblity = user['postDefaultVisiblity']
          this.userService.user.isVisibleOnSearch = user['isVisibleOnSearch']
          this.userService.user.token = token;
          this.isLoggedIn = true;
          this.userService.user.lastUpdateFromServer = new Date();
          
          if(user['organization'] && user['organizationMember']) {
            if(!this.userService.user.organizationMember)
              this.userService.user.organizationMember = new OrganizationMember()
            this.userService.user.organizationMember.id = user['organizationMember']['id']
            this.userService.user.organizationMember.userId = user['organizationMember']['userId']
            this.userService.user.organizationMember.firstName = user['organizationMember']['firstName']
            this.userService.user.organizationMember.lastName = user['organizationMember']['lastName']
            this.userService.user.organizationMember.isRoleAdmin = user['organizationMember']['isRoleAdmin']
            this.userService.user.organizationMember.isRoleWriteMembers = user['organizationMember']['isRoleWriteMembers']
            this.userService.user.organizationMember.isRoleReadMembers = user['organizationMember']['isRoleReadMembers']
            this.userService.user.organizationMember.isRoleWriteAnimals = user['organizationMember']['isRoleWriteAnimals']
            this.userService.user.organizationMember.isRoleReadAnimals = user['organizationMember']['isRoleReadAnimals']
            this.userService.user.organizationMember.isRoleWriteAgenda = user['organizationMember']['isRoleWriteAgenda']
            this.userService.user.organizationMember.isRoleReadAgenda = user['organizationMember']['isRoleReadAgenda']
            this.userService.user.organizationMember.isRoleWritePlan = user['organizationMember']['isRoleWritePlan']
            this.userService.user.organizationMember.isRoleReadPlan = user['organizationMember']['isRoleReadPlan']

            this.userService.user.organizationMember.isRoleWritePharmacy = user['organizationMember']['isRoleWritePharmacy']
            this.userService.user.organizationMember.isRoleReadPharmacy = user['organizationMember']['isRoleReadPharmacy']
            this.userService.user.organizationMember.isRoleWriteShare = user['organizationMember']['isRoleWriteShare']
            this.userService.user.organizationMember.isRoleReadShare = user['organizationMember']['isRoleReadShare']
            this.userService.user.organizationMember.isRoleWriteFosterFamily = user['organizationMember']['isRoleWriteFosterFamily']
            this.userService.user.organizationMember.isRoleReadFosterFamily = user['organizationMember']['isRoleReadFosterFamily']
            this.userService.user.organizationMember.isRoleWriteVet = user['organizationMember']['isRoleWriteVet']
            this.userService.user.organizationMember.isRoleReadVet = user['organizationMember']['isRoleReadVet']
            this.userService.user.organizationMember.isRoleWriteOrganization = user['organizationMember']['isRoleWriteOrganization']
            this.userService.user.organizationMember.isBenevoleWalker = user['organizationMember']['isBenevoleWalker']
            this.userService.user.organizationMember.isRoleWriteCompta = user['organizationMember']['isRoleWriteCompta']
            this.userService.user.organizationMember.isRoleReadCompta = user['organizationMember']['isRoleReadCompta']

            
            if(!this.userService.user.organization) {
              this.userService.user.organization = this.organizationService.organizations.find(a => a.id == user?.organization?.id) ?? null
              if(!this.userService.user.organization) {
                this.userService.user.organization = new Organization()
                this.organizationService.organizations.push(this.userService.user.organization)
              }
            }
            this.userService.user.organization.id = user['organization']['id']
            this.userService.user.organization.name = user['organization']['name']
            this.userService.user.organization.types = user['organization']['types']
            this.userService.user.organization.avatar = user['organization']['avatar']
            this.userService.user.organization.userId = user['organization']['userId']
            this.userService.user.organization.subscription = user['organization']['subscription']
            this.userService.user.organization.postDefaultVisiblity = user['organization']['postDefaultVisiblity']
            this.userService.user.organization.postDefaultVisiblityLitter = user['organization']['postDefaultVisiblityLitter']
            this.userService.user.organization.affix = user['organization']['affix']
            this.userService.user.organization.isActivePublicPage = user['organization']['isActivePublicPage']
  
            if(user['organization']['avatarBase64'] != null) {
              this.userService.user.organization.avatarBase64 = user['organization']['avatarBase64'];
            } else if(this.userService.user.organization.avatar != null) {
              this.userService.user.organization.avatarBase64 = null;
              this.http.get(this.userService.user.organization.avatar,  { responseType: 'blob' as 'blob' }).subscribe(data => {
                blobToBase64(data).then((res: any) =>  {
                  if(this.userService.user?.organization)
                    this.userService.user.organization.avatarBase64 = res;
                });
              });
            } else {
            }
          }

          this.storageService.set('user', this.userService.user );

          setTimeout(() => {
            this._statusChange$.next(true);
            if(redirect_url)
              this.router.navigate([redirect_url]);
          }, 50);
        }

      }, error => {
        this.reloadRunning = false;
        if(this.userService.user)
          this.userService.user.lastUpdateFromServer = null;
      })
    )
  }

  logout() {
    const headers = new HttpHeaders({
      'Authorization': this.userService.getHttpHeaders()
    });
    
    this.logoutDeleteLocalData();

    return this.http.post(environment.API_URL + 'userProfile/ws_private/Logout/', {}, { headers: headers })
    .pipe(
      tap(data => {
        this.userService.user = null;
        this._statusChange$.next(false);
        this._logout$.next(false);
        return data;
      })
    ).subscribe();
  }

  async logoutDeleteLocalData() {
    this.storageService.remove("user");
    this.isLoggedIn = false;
    if(this.userService.user != null)
      this.userService.user.token = null;
    this.userService.user = null;
    this.username = null;
    this.notifications = []
  }
  
  getIsLoggedIn() {
    return this.getToken();
  }

  async getToken(forceUpdate = false) {
    // Attendre que le storage soit prêt
    const storageReady = await this.storageService.waitForReady();
    if (!storageReady) {
      console.error('Storage initialization timeout');
      this.isLoggedIn = false;
      this._statusChange$.next(false);
      return Promise.resolve(null);
    }

    if(!forceUpdate && this.userService.user != null && this.userService.user.token != null && this.userService.user.lastUpdateFromServer != null &&new Date().getTime() - this.userService.user.lastUpdateFromServer.getTime() < 5 * 60 * 1000) {
      this.isLoggedIn=true;
      return new Promise(resolve => {
        resolve(null);
      });
    } else {
      return this.storageService.get('user').then(
        data => {
          if(data != null) {
            this.userService.user = data;
            this.userService.user = Object.assign(new User(), this.userService.user);
            this.userService.user.organizationMember = Object.assign(new OrganizationMember(), this.userService.user.organizationMember);
            this.userService.user.organization = Object.assign(new Organization(), this.userService.user.organization);
            if(this.userService.user) {
              this.username = this.userService.user.email;
              this.userService.user.lastUpdateFromServer = new Date()
            }
          } else {
            this.logoutDeleteLocalData();
          }
          
          if(this.userService.user?.token != null && this.username != null) {
            this.reloadUser(this.userService.user?.token, this.username, null)?.subscribe((data) => {});
            this.isLoggedIn=true;
            this._statusChange$.next(true);
          } else {
            this.isLoggedIn=false;
            this._statusChange$.next(false);
          }
        },
        async error => {
          console.error('Error getting user from storage:', error);
          if(this.userService.user != null)
            this.userService.user.token = null;
          this.userService.user = null;
          this.isLoggedIn=false;
          this._statusChange$.next(false);
        }
      );
    }
  }

  setNotifications(notifications: []) {
    this.notifications = notifications;
    this._notificationsUpdate$.next(true);
  }
}
